import React, {useState, useRef, useEffect} from 'react';

import { Icon } from '../IconExporter';
import { Dropdown } from '../Dropdown';
import { Container, ItemsContainer } from './styles';

type SearchBoxProps = {
  data: string[];
  type?: 'simple' | 'complex';
  placeholder?: string;
  onChangeCallback?: (value: string) => void;
}

export const SearchBox = ({ data, type = 'complex', onChangeCallback, placeholder = '' }: SearchBoxProps) => {

  const [items, setItems] = useState(data ?? []);
  const [inputValue, setInputValue] = useState('');
  const itemsRef = useRef<string[]>([]);
  const containerRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    if (data.length > 0) {
      itemsRef.current =  data;
    }
  }, [data])

  useEffect(() => {
    if (inputValue === '') {
      setItems(itemsRef.current);
    } else {
      handleFilter(inputValue);
    }
    if (onChangeCallback) onChangeCallback(inputValue);
  }, [inputValue, onChangeCallback])

  const handleFilter = (value: string) => {
    const filteredValue = itemsRef.current.filter(item => 
      item.toLocaleLowerCase().includes(value.toLocaleLowerCase())
    );
    setItems(filteredValue);
    setInputValue(value);
  };

  const getItems = () => {
    if (items && items.length > 0) {
      return <ItemsContainer>
      {items.map(item => 
        <p key={item} onClick={() => {
          setInputValue(item);
          containerRef.current?.click();
        }}>
          {item}
        </p>  
      )}
    </ItemsContainer>
    }
    return null;
  }
  
  return <Dropdown fitToParentWidth dropContent={getItems()}>
    <Container type={type} hasValue={!!inputValue} ref={containerRef}>
    {type === 'complex' && <Icon name="busca" size={15}/>}
    <input 
      type="text" 
      value={inputValue} 
      onChange={(e) => setInputValue(e.target.value)}
      placeholder={placeholder}
    />
    {type === 'simple' && <Icon name="busca" size={15}/>}
    </Container>
  </Dropdown>
}